import { useEffect } from "react";
import {
  HeadingText,
  Modal,
  ParagraphText,
  StackLayout,
} from "@leagueplatform/genesis-core";
import {
  EVENT_NAME,
  PRODUCT_AREA,
  trackAnalyticsEvent,
} from "@leagueplatform/analytics";
import { useIntl } from "@leagueplatform/locales";
import { ANALYTICS_SCREEN_NAMES, DETAIL } from "common/constants";
import { BaseModalContainer } from "components/modals/common/base-modal-container.component";
import { ModalActionButton } from "components/modals/common/modal-action-button.component";

export const AccountDeletedModal = () => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    trackAnalyticsEvent(EVENT_NAME.SCREEN_LOADED, {
      product_area: PRODUCT_AREA.SETTINGS,
      screen_name: ANALYTICS_SCREEN_NAMES.DELETION_CONFIRMATION,
    });
  }, []);

  return (
    <BaseModalContainer
      footer={
        <StackLayout horizontalAlignment="end" css={{ flexGrow: 0 }}>
          <ModalActionButton
            actionType="close"
            buttonText={formatMessage({ id: "STR_I_UNDERSTAND" })}
            priority="primary"
            trackAnalytics={{
              product_area: PRODUCT_AREA.SETTINGS,
              screen_name: ANALYTICS_SCREEN_NAMES.DELETION_CONFIRMATION,
              detail: DETAIL.ACKNOWLEDGE_DELETION,
            }}
          />
        </StackLayout>
      }
    >
      <Modal.Title>
        <HeadingText level="2" size="lg">
          {formatMessage({ id: "STR_ACCOUNT_DELETED_HEADING" })}
        </HeadingText>
      </Modal.Title>
      <ParagraphText>
        {formatMessage({ id: "STR_ACCOUNT_DELETED_BODY_1" })}
      </ParagraphText>
    </BaseModalContainer>
  );
};
